import * as types from './types';

export default {
  [types.EMIT_SAVE_USER_INFORMATION]: ({ commit }, userInformation) => {
    commit(types.SAVE_USER_INFORMATION, userInformation);
  },
  [types.EMIT_SAVE_ASSESSMENT]: ({ commit }, assessment) => {
    commit(types.SAVE_ASSESSMENT, assessment);
  },
  [types.EMIT_SAVE_DICTIONARY]: ({ commit }, dictionary) => {
    commit(types.SAVE_DICTIONARY, dictionary);
  },
  [types.EMIT_SAVE_ANSWERERINFO]: ({ commit }, answererInfo) => {
    commit(types.SAVE_ANSWERERINFO, answererInfo);
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js